
import { Component, OnInit } from '@angular/core';
import { FinanceiroService } from '../financeiro.service';
import { AcessoApiService } from '../../../acessoApi.service';
import { Router } from '@angular/router';
import { DadosAcessoService } from '../../../dadosAcesso.service';

@Component({
  selector: 'app-visualizar-pdf',
  templateUrl: './visualizar-pdf.component.html',
  styleUrls: ['./visualizar-pdf.component.css']
})
export class VisualizarPdfComponent implements OnInit {

  public idBlto: number;
  public codLoja: string;

  public datar;
  public pdfnew: Uint8Array;

  constructor(private dadosAcesso: DadosAcessoService,
      private router: Router,
      private acessoAPI: AcessoApiService,
      private financeiroService: FinanceiroService) {
  }

  ngOnInit() {
    this.BurcarBoleto();
  }

  BurcarBoleto() {

    this.codLoja = sessionStorage.getItem('cod_loja');
    this.idBlto = this.financeiroService.recuperarIDBoleto();

    if (this.idBlto === undefined) {
      this.router.navigate(['/financeiro']);
    }

    this.acessoAPI.getDadosBoleto(this.idBlto).subscribe(data => {

      this.datar = data;


      this.pdfnew = this.base64ToUint8Array(data);

    }, error => {
     

    });
  }

  showpdf() {

    const linksource = `data:application/pdf;base64, ${this.datar}`;
    const downloadlink = document.createElement('a');
    const fileName = 'BoletoRCKY.pdf';

    downloadlink.href = linksource;
    downloadlink.download = fileName;
    downloadlink.click();
  }

  base64ToUint8Array(base64: string) {
    const raw = atob(base64);
    const uint8Array = new Uint8Array(raw.length);
    for (let i = 0; i < raw.length; i++) {
      uint8Array[i] = raw.charCodeAt(i);
    }
    return uint8Array;
  }

  VoltarBoleto() {
    this.router.navigate(['/financeiro']);
  }

  ImprimirBoleto() {
    const winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,resizable,screenX=50,screenY=50,width=850,height=1050';

    const htmlText = '<embed width=100% height=100%'
              + ' type="application/pdf"'
              + ' src="data:application/pdf;base64,' + this.datar + '"></embed>';
    const detailWindow = window.open('', 'w', winparams);
    detailWindow.document.write(htmlText);
    detailWindow.document.title = 'Boleto RCKY';
    detailWindow.document.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/financeiro/visualizar-pdf/visualizar-pdf.component.ts